import apiClient from "../../../utils/interceptor";
import {
  ApiResponse,
  UserData,
  CreateUserParams,
  CreateUserResponse,
  UpdateUserStatusParams,
} from "./interface";
import { API_URLS } from "../../../constants";

// Helper function to get auth token from localStorage
const getAuthToken = (): string | null => {
  return localStorage.getItem("auth_token");
};

export const getUsersByCompanyId = async (
  companyId: string
): Promise<ApiResponse<UserData[]>> => {
  const token = getAuthToken();

  try {
    const response = await apiClient.get<ApiResponse<UserData[]>>(
      `${API_URLS.COMPANY.GET_USERS_BY_COMPANY_ID}/${companyId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching users by company ID:", error);
    throw error;
  }
};

export const getRegionAdminsByCompanyId = async (
  companyId: string
): Promise<ApiResponse<UserData[]>> => {
  const token = getAuthToken();

  try {
    const response = await apiClient.get<ApiResponse<UserData[]>>(
      `${API_URLS.COMPANY.GET_REGION_ADMINS_BY_COMPANY_ID}/${companyId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Error fetching region admins by company ID:", error);
    throw error;
  }
};

// Function to create a user
export const createUser = async (
  userParams: CreateUserParams
): Promise<ApiResponse<CreateUserResponse>> => {
  const token = getAuthToken();

  try {
    const response = await apiClient.post<ApiResponse<CreateUserResponse>>(
      API_URLS.USER.CREATE_USER,
      userParams,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error creating user:", error);
    throw error;
  }
};

export const updateUserStatus = async (
  params: UpdateUserStatusParams
): Promise<ApiResponse<{ message: string }>> => {
  const token = getAuthToken();

  try {
    const response = await apiClient.patch<ApiResponse<{ message: string }>>(
      API_URLS.COMPANY.UPDATE_USER_STATUS,
      params,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error updating user status:", error);
    throw error;
  }
};
